import React from "react";
import { Routes, Route } from "react-router-dom";
import ShopList from "./shop-list";

//
const Shop = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route path="" element={<ShopList />} />
        <Route path="/" element={<ShopList />} />
      </Routes>
    </React.Fragment>
  );
};

export default Shop;
